import { useMemo, useState } from "react";
import { Plus, Wrench } from "lucide-react";
import { Page, Panel, Table, DeleteButton, SearchInput } from "../lib/ui";
import { money, can, rowLink } from "../lib/api";

export default function Services({ rows, setModal, onDelete, user }) {
  const [q, setQ] = useState("");
  const filtered = useMemo(() => rows.filter((s) => {
    if (!q) return true;
    const bag = [s.code, s.name, s.description, s.category].filter(Boolean).map((x) => String(x).toLowerCase()).join(" ");
    return bag.includes(q.toLowerCase());
  }), [rows, q]);
  const isAdmin = user?.role === "admin";
  return (
    <>
      <Page
        eyebrow="HİZMET KATALOĞU"
        title="Hizmetler"
        subtitle="Ürünlerin yanına, tekrar eden hizmet kalemlerini kod ve birim ücretle kaydedin."
        action={
          <button data-testid="add-services-button" className="primary-button"
                  disabled={!isAdmin}
                  title={!isAdmin ? "Sadece yönetici hizmet ekleyebilir" : ""}
                  onClick={() => setModal({ type: "service" })}>
            <Plus size={17} /> Hizmet ekle
          </button>
        }
      />
      <Panel className="module-panel"
             action={<SearchInput value={q} onChange={setQ} testid="services-search" placeholder="Kod, isim, açıklama" />}
      >
        <Table
          testid="services-table"
          columns={[
            { label: "Kod" }, { label: "Hizmet adı" }, { label: "Kategori" },
            { label: "Birim" }, { label: "Birim ücret", align: "right" }, { label: "KDV", align: "right" }, { label: "" },
          ]}
          rows={filtered}
          empty="Henüz hizmet kaydı yok."
          renderRow={(s) => (
            <tr key={s.id} data-testid={`service-row-${s.id}`} className="clickable-row"
                {...rowLink(`/detay/hizmet/${s.id}`)}
                style={{ cursor: "pointer" }}>
              <td><a href={`/detay/hizmet/${s.id}`} className="row-anchor" onClick={(e) => e.stopPropagation()}><strong className="code">{s.code}</strong></a></td>
              <td>
                <Wrench size={12} style={{marginRight:6, color:"#64748b"}} />
                {s.name}
                <small>{s.description || "—"}</small>
              </td>
              <td>{s.category || "—"}</td>
              <td>{s.unit || "Adet"}</td>
              <td className="amount">{money(s.price)}</td>
              <td className="amount" data-testid={`service-kdv-${s.id}`}>%{s.kdv ?? 20}</td>
              <td className="amount" onClick={(e) => e.stopPropagation()}>
                <DeleteButton
                  testid={`delete-service-${s.id}`}
                  disabled={!isAdmin}
                  onClick={() => onDelete(s)}
                />
              </td>
            </tr>
          )}
        />
      </Panel>
    </>
  );
}
